import { useState } from "react";
import { Search, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

export function RegblButton({ egid, disabled, onResult }) {
  const [loading, setLoading] = useState(false);
  const lookup = async () => {
    const id = (egid || "").trim();
    if (!/^\d+$/.test(id)) return toast.error("Saisissez d'abord un n° EGID numérique.");
    setLoading(true);
    try {
      const { data } = await api.get(`/regbl/${id}`);
      onResult(data);
      toast.success(`RegBL : ${data.immeuble}, ${data.npa} ${data.localite}`);
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setLoading(false);
    }
  };
  return (
    <Button type="button" variant="outline" size="sm" data-testid="regbl-lookup-btn" disabled={disabled || loading}
      onClick={lookup} className="h-11 shrink-0 gap-1.5" title="Pré-remplir l'adresse depuis le registre fédéral des bâtiments">
      {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Search className="h-4 w-4" />}
      RegBL
    </Button>
  );
}
